import { fetchUtils } from './fetchUtils'
import type { Catalog } from '../map/types/catalog'
import type { Material } from '../map/types/material'

export function getMaterialCatalogsAndMaterialOptions(): Promise<{
	catalogDefaults: Catalog[]
	materialDefaultsMap: Record<string, Material[]>
}> {
	return fetchUtils.get('/api/catalogsandmaterials/svelte/defaults', false)
}
